import React from 'react';

import { FlyoutTrigger } from '@atlassian/entry-point-flyout';
import type { ObjectListFlyoutProps } from '@atlassian/navigation-common/types';

import { objectListFlyoutEntrypoint } from './object-list-flyout-content/entrypoint';

/**
 * Component that renders a list of items in a flyout menu with searching & filtering capabilities in the list.
 * Consumers can provide the items data via the useItems hook.
 */
export function ObjectListFlyout(props: ObjectListFlyoutProps): React.JSX.Element {
	const {
		dropIndicator,
		elemBefore,
		entryPoint = objectListFlyoutEntrypoint,
		entryPointParams,
		errorFallback,
		fallback,
		hasDragIndicator,
		isDefaultOpen,
		isDragging,
		isFlyoutOpen,
		label,
		labelElem,
		onClick,
		onOpenChange,
		testId,
		triggerRef,
		visualContentRef,
	} = props;

	return (
		<FlyoutTrigger
			entryPoint={entryPoint}
			entryPointProps={props}
			entryPointParams={entryPointParams}
			errorFallback={errorFallback}
			fallback={fallback}
			isDefaultOpen={isDefaultOpen}
			onOpenChange={onOpenChange}
			isFlyoutOpen={isFlyoutOpen}
			triggerProps={{
				elemBefore,
				children: labelElem ?? label,
				onClick,
				testId,
				hasDragIndicator,
				isDragging,
				dropIndicator,
				triggerRef,
				visualContentRef,
			}}
		/>
	);
}
